<ws-modal-wrapper headerLabel="Income Statement Categories"
                  [hideFooter]="true"
                  (cancel)="cancel()">
    <div class="ws-picker-tree">
        @if (incomeStatementCategories) {
            <ul>
                @for (topLevel of incomeStatementCategories; track topLevel; let i = $index) {
                    <li>
                        <div [ngClass]="i % 2 ? 'tree-line-holder-odd' : 'tree-line-holder-even'">
                            @if (!isExpanded(topLevel)) {
                                <span class="node-collapsed"
                                      [ngClass]="topLevel.childIncomeStatementCategories.length > 0 ? '' : 'empty-tree-node'"
                                      (click)="expandCategory(topLevel)"></span>
                            } @else {
                                <span class="node-expanded"
                                      [ngClass]="topLevel.childIncomeStatementCategories.length > 0 ? '' : 'empty-tree-node'"
                                      (click)="collapseCategory(topLevel)"></span>
                            }
                            <span class="entity-link"
                                  [ngClass]="isSelected(topLevel) ? 'active-entity-link' : ''"
                                  (click)="selectIncomeStatementCategory(topLevel)"
                                  [title]="topLevel.name">{{ topLevel.name }}</span>
                        </div>
                        @if (isExpanded(topLevel)) {
                            <ul [@pickerEnter]>
                                @for (secondLevel of topLevel.childIncomeStatementCategories; track secondLevel; let
                                    j = $index) {
                                    <li>
                                        <div class="tree-line-level-2"
                                             [ngClass]="(i + j + 1) % 2 ? 'tree-line-holder-odd' : 'tree-line-holder-even'">
                                            @if (!isExpanded(secondLevel)) {
                                                <span class="node-collapsed"
                                                      [ngClass]="secondLevel.childIncomeStatementCategories.length > 0 ? '' : 'empty-tree-node'"
                                                      (click)="expandCategory(secondLevel)"></span>
                                            } @else {
                                                <span class="node-expanded"
                                                      [ngClass]="secondLevel.childIncomeStatementCategories.length > 0 ? '' : 'empty-tree-node'"
                                                      (click)="collapseCategory(secondLevel)"></span>
                                            }
                                            <span class="entity-link"
                                                  [ngClass]="isSelected(secondLevel) ? 'active-entity-link' : ''"
                                                  (click)="selectIncomeStatementCategory(secondLevel)"
                                                  [title]="secondLevel.name">{{ secondLevel.name }}</span>
                                        </div>
                                        @if (isExpanded(secondLevel)) {
                                            <ul [@pickerEnter]>
                                                @for (
                                                    thirdLevel of secondLevel.childIncomeStatementCategories; track thirdLevel; let
                                                    k = $index) {
                                                    <li>
                                                        <div class="tree-line-level-3"
                                                             [ngClass]="(i + j + k) % 2 ? 'tree-line-holder-odd' : 'tree-line-holder-even'">
                                                            <span class="entity-link"
                                                                  [ngClass]="isSelected(thirdLevel) ? 'active-entity-link' : ''"
                                                                  (click)="selectIncomeStatementCategory(thirdLevel)"
                                                                  [title]="thirdLevel.name">{{ thirdLevel.name }}</span>
                                                        </div>
                                                    </li>
                                                }
                                            </ul>
                                        }
                                    </li>
                                }
                            </ul>
                        }
                    </li>
                }
            </ul>
        }
    </div>
</ws-modal-wrapper>
